import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { LinePayload } from '../common/payload.types';
import type { PaymentTerm } from '../common/types';
import type { InvoiceTemplateInterval } from './types';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { invoiceTemplateSchema } from './schemas';
import { invoiceTemplateQueryOptions } from './useInvoiceTemplate';

export type Payload = {
  brandId: number | null;
  clientContactId: number | null;
  clientId: number | null;
  clientReference: string | null;
  conditionId: number | null;
  customAgreementId: number | null;
  customConditionId: number | null;
  description: string | null;
  interval: InvoiceTemplateInterval | null;
  lines: LinePayload[];
  nextInvoiceAt: string | null;
  numberingSeriesId: number | null;
  paymentTerm: PaymentTerm;
  paymentTermEndOfMonth: boolean;
  specialConditions: string | null;
  title: string;
};

export const useCreateInvoiceTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: Payload) => {
      const { data: invoiceTemplate } = await fetchJson('/invoice-templates', {
        method: 'POST',
        schema: apiResourceSchema(invoiceTemplateSchema),
        body,
      });

      return invoiceTemplate;
    },
    onSuccess: (invoiceTemplate) => {
      queryClient.setQueryData(invoiceTemplateQueryOptions(invoiceTemplate.id).queryKey, invoiceTemplate);
      queryClient.invalidateQueries({ queryKey: QueryKeys.invoiceTemplates.index.root });
    },
  });
};
